export function getRepeatValidationError({
  repeatRule,
  repeatEndMode,
  repeatUntil,
  start,
}) {
  const normalizedRule = String(repeatRule || "none");
  const normalizedEndMode =
    String(repeatEndMode || (normalizedRule === "forever" ? "forever" : "frequency"));

  if (normalizedRule === "none") {
    return "";
  }

  if (normalizedEndMode !== "until") {
    return "";
  }

  const untilDate = String(repeatUntil || "").trim();
  if (!untilDate) {
    return "Please select a repeat-until date.";
  }

  const startDateOnly = String(start || "").slice(0, 10);
  if (startDateOnly && untilDate < startDateOnly) {
    return "Repeat-until date must be on or after the start date.";
  }

  return "";
}
